// src/store/roster/reducers/rosterReducer.js

import {
  GET_ROSTER_REQUEST,
  GET_ROSTER_SUCCESS,
  GET_ROSTER_FAILURE,
  SAVE_ROSTER_REQUEST,
  SAVE_ROSTER_SUCCESS,
  SAVE_ROSTER_FAILURE,
  SUBMIT_ROSTER_REQUEST,
  SUBMIT_ROSTER_SUCCESS,
  SUBMIT_ROSTER_FAILURE,
  DOWNLOAD_ROSTER_PDF_REQUEST,
  DOWNLOAD_ROSTER_PDF_SUCCESS,
  DOWNLOAD_ROSTER_PDF_FAILURE,
} from "../actions/rosterActionsCreators";

const initialState = {
  roster: null,
  isLoading: false,
  error: null,
  isSaving: false,
  isSubmitting: false,
  isDownloading: false,
};

export const rosterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROSTER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_ROSTER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roster: action.payload,
        error: null,
      };
    case GET_ROSTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case SAVE_ROSTER_REQUEST:
      return {
        ...state,
        isSaving: true,
        error: null,
      };
    case SAVE_ROSTER_SUCCESS:
      return {
        ...state,
        isSaving: false,
        roster: action.payload,
        error: null,
      };
    case SAVE_ROSTER_FAILURE:
      return {
        ...state,
        isSaving: false,
        error: action.payload,
      };

    case SUBMIT_ROSTER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        error: null,
      };
    case SUBMIT_ROSTER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        roster: action.payload,
        error: null,
      };
    case SUBMIT_ROSTER_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
      };

    case DOWNLOAD_ROSTER_PDF_REQUEST:
      return {
        ...state,
        isDownloading: true,
        error: null,
      };
    case DOWNLOAD_ROSTER_PDF_SUCCESS:
      return {
        ...state,
        isDownloading: false,
        error: null,
      };
    case DOWNLOAD_ROSTER_PDF_FAILURE:
      return {
        ...state,
        isDownloading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
